import React, {useState, useEffect} from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Auth,
} from 'aws-amplify'

import NavBar from '../Components/Action/NavBar'
import AppContainer from '../Components/Display/AppContainer'

import { 
    Alert,
    Info,
    PageDiv,
    WhiteDiv,
    HeaderDiv
} from '../Styles/BaseStyles'

import {
    ComponentsDiv
} from '../Styles/Pages/HubStyles'

import { 
    useSelector, 
    useDispatch 
} from 'react-redux'

import { 
    reset as appViewerReset 
} from '../Redux/Slices/AppViewerSlice'

import { 
    resetAlert 
} from '../Redux/Slices/HubSlice'

import { 
    showAlert as showSettingsAlertBox 
} from '../Redux/Slices/SettingsSlice'

function Hub(props){
    let history = useHistory()

    const dispatch = useDispatch()

    const [load, setLoad] = useState(false)

    const storage = useSelector(state => state.user.storage)

    const error = useSelector(state => state.hub.error)
    const errorPhrase = useSelector(state => state.hub.errorPhrase)
    const info = useSelector(state => state.hub.info)
    const infoPhrase = useSelector(state => state.hub.infoPhrase)

    const user = useSelector(state => state.user.user)

    const paymentRequired = useSelector(state => state.hub.paymentRequired)

    dispatch(appViewerReset())

    useEffect(() => {
        switch(storage){
            case 'localstorage':
                Auth.configure({storage: localStorage})
                break
            case 'sessionstorage':
                Auth.configure({storage: sessionStorage})
                break
            default:
                break
        }
        Auth.currentAuthenticatedUser().then(() => {
            if(!paymentRequired || user.user_group !== 'none'){
                setLoad(true)
            }
            else{
                dispatch(showSettingsAlertBox({alertType: 'subscription'}))
                history.push('/settings')
            }
            /*if(user.email_verified && user.phone_number_verified){
                setLoad(true)
            }
            else{
                dispatch(showSettingsAlertBox({alertType: 'verification'}))
                history.push('/settings')
            }*/
        })
        .catch(() => {
            history.push('/login')
        })
    }, [])

    useEffect(() => {
        if(error || info){
            const timeId = setTimeout(() => {
                dispatch(resetAlert())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error,info])

    var viewer = (
        <>
        </>
    )

    if(load){
        viewer = (
            <PageDiv>
                <HeaderDiv>
                    <WhiteDiv>
                        <NavBar page="Hub"/>
                    </WhiteDiv>
                </HeaderDiv>
                <ComponentsDiv>
                    {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
                    {info && <Info style={{top: "0.5rem", position: "absolute"}}>{infoPhrase}</Info>}
                    <AppContainer />
                </ComponentsDiv>
            </PageDiv>
        )
    }

    return (
        <>
            {viewer}
        </>
    )
}

export default Hub